import {
  Artwork,
  ExportableArtwork,
  formatSupport,
  formatTechnique,
  getServerImageUrl,
  Support,
  Technique,
} from './../constants';
import * as XLSX from 'xlsx';

const preProcessData = (data: Artwork[]): ExportableArtwork[] => {
  const processedData = [] as ExportableArtwork[];

  for (let i = 0; i < data.length; i++) {
    const artwork = <ExportableArtwork>{};

    if (data[i].imageId) {
      artwork.imageUrl = getServerImageUrl(data[i].imageId);
    }

    artwork.title = data[i].title;
    artwork.reference = data[i].reference;
    artwork.format = data[i].format;
    artwork.madeDate = data[i].madeDate;
    artwork.availability = data[i].availability;

    if (data[i].support) {
      artwork.support = formatSupport(data[i].support as Support);
    }
    if (data[i].technique) {
      artwork.technique = formatTechnique(data[i].technique as Technique);
    }

    if (data[i].price) {
      artwork.price = (data[i].price || 0) / 100;
    }
    if (data[i].priceWithoutTax) {
      artwork.priceWithoutTax = (data[i].priceWithoutTax || 0) / 100;
    }

    if (data[i].project) {
      artwork.projectTitle = data[i].project?.title;
    }

    if (data[i].currentLocation) {
      artwork.currentLocationTitle = data[i].currentLocation?.title;
    }

    processedData.push(artwork);
  }
  return processedData;
};

export async function exportDataXlsx(
  data: ExportableArtwork[],
  fileTitle: string,
) {
  if (!data || data.length === 0) return;

  const header = Object.keys(data[0]);
  const rows = data.map((row) => header.map((key) => (row as any)[key] ?? ''));
  const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);

  const imageColIndex = header.indexOf('imageUrl');
  if (imageColIndex >= 0) {
    data.forEach((row, i) => {
      if (row.imageUrl) {
        const cellRef = XLSX.utils.encode_cell({ r: i + 1, c: imageColIndex });
        (ws as any)[cellRef] = { f: `IMAGE("${row.imageUrl}")` };
      }
    });
  }

  (ws as any)['!rows'] = [
    { hpx: 30 },
    ...data.map(() => ({ hpx: 100 })),
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Export');

  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileTitle}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const exportData = async (
  columns: any[],
  data: Artwork[],
  fileTitle: string,
) => {
  const processedData = preProcessData(data);
  return exportDataXlsx(processedData, fileTitle);
};
